__turbopack_context__.v({
  "root": "Textarea-module-scss-module__GUL82W__root",
});
